export default {
  props: {
    value: {},
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default() {
        return true
      }
    },
    placeholder: String
  },
  computed: {}
}
